import * as R from 'ramda';
import {
  Notification,
} from 'element-ui';

const tip = {
  default: (message = '', type = 'success', duration = 4000) => {
    if (R.is(Object, message)) {
      Notification({
        message: R.prop('message', message) || '',
        type: R.prop('type', message) || type,
        customClass: 'global-notification',
        duration: R.prop('duration', message) || duration,
      });
      return;
    }

    Notification({
      message,
      type,
      duration,
    });
  },
  success: (message = '', duration = 4000) => {
    tip.default(message, 'success', duration);
  },
  info: (message = '', duration = 4000) => {
    tip.default(message, 'info', duration);
  },
  warning: (message = '', duration = 4000) => {
    tip.default(message, 'warning', duration);
  },
  error: (message = '', duration = 4000) => {
    tip.default(message, 'error', duration);
  },
};

export default tip;



// WEBPACK FOOTER //
// ./src/utils/tip/index.js